import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {  PopoverModule } from 'ngx-bootstrap/popover';
import { SearchBarComponent } from './search-bar.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MessageModule } from '@global-message/Message.module';
import { cloneService } from '@global-services/CloneService';
import { CustomerService } from 'app/vbt-back-office/Customer/_services/Customer.service';
import { RouterModule } from '@angular/router';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule,
        PopoverModule,
        BsDatepickerModule,
        MessageModule,
        RouterModule
    ],
    exports: [
        SearchBarComponent
    ],
    declarations: [
        SearchBarComponent
    ],
    providers: [
        cloneService,
        CustomerService
    ]
})

export class SearchBarModule {
    constructor() {
    }
}